// @flow
import JQueryView from './JQueryView';
import $ from 'jquery';

export default class HeaderScrollView extends JQueryView {
  constructor() {
    super('.after-login-header');

    const $leftArrowCont = $('.jsc-logoWrap'),
      $rightArrowCont = $('.jsc-headerLoginCont'),
      $headerNavWrap = $('.jsc-headerNavWrap'),
      $navList = $('.jsc-headerNavWrap').children('ul'),
      scrollRange = 150; // 矢印クリック時にスクロールされる幅

    // 初期表示&リサイズ時挙動
    $(window).on('load resize', () => {
      // 左端の制御
      if ($headerNavWrap.get(0).scrollLeft == 0) {
        this.hiddenArrowIcon($leftArrowCont);
      } else {
        this.showArrowIcon($leftArrowCont);
      }

      // 右端の制御
      if (
        this.scrollFlg($headerNavWrap, $navList) &&
        $headerNavWrap.get(0).scrollWidth -
          ($headerNavWrap.get(0).clientWidth +
            $headerNavWrap.get(0).scrollLeft) !=
          0
      ) {
        this.showArrowIcon($rightArrowCont);
      } else {
        this.hiddenArrowIcon($rightArrowCont);
      }
    });

    // スクロール時の挙動
    $headerNavWrap[0].addEventListener('wheel', e => {
      e.stopPropagation();
      $headerNavWrap.scrollLeft += e.deltaX;

      // 左端の制御
      if ($headerNavWrap.get(0).scrollLeft == 0) {
        this.hiddenArrowIcon($leftArrowCont);
      } else {
        this.showArrowIcon($leftArrowCont);
      }

      // 右端の制御
      if (
        $headerNavWrap.get(0).scrollLeft >=
        $headerNavWrap.get(0).scrollWidth - $headerNavWrap.get(0).clientWidth
      ) {
        this.hiddenArrowIcon($rightArrowCont);
      } else {
        this.showArrowIcon($rightArrowCont);
      }
    });

    // アイコンクリック時の挙動
    $('.jsc-arrow').on('click', e => {
      const dir = e.target.dataset.direction;

      if (dir == 'left') {
        $headerNavWrap.get(0).scrollLeft -= scrollRange;
        this.showArrowIcon($rightArrowCont);

        if ($headerNavWrap.get(0).scrollLeft == 0) {
          // 左端で非表示
          this.hiddenArrowIcon($leftArrowCont);
        }
      } else if (dir == 'right') {
        $headerNavWrap.get(0).scrollLeft += scrollRange;
        this.showArrowIcon($leftArrowCont);

        if (
          $headerNavWrap.get(0).scrollLeft >=
          $headerNavWrap.get(0).scrollWidth - $headerNavWrap.get(0).clientWidth
        ) {
          // 右端で非表示
          this.hiddenArrowIcon($rightArrowCont);
        }
      }
    });
  }

  // グロナビに表示される横幅(scroll-nav)と実際の横幅(tab-nav)を比較し、実際の横幅の方が大きい場合はスクロールが必要になる
  scrollFlg = (_navWrap: any, _navList: any) =>
    _navWrap.width() < _navList.width();

  showArrowIcon = (_target: any) => {
    _target.addClass('is-scroll');
  };

  hiddenArrowIcon = (_target: any) => {
    _target.removeClass('is-scroll');
  };
}
